<template>
  <el-container>
    <el-header style="height: auto;">
      <el-form>
        <el-form-item label="类型">
          <el-select v-model="conditions.cardType">
            <el-option :value="1" label="景区卡"></el-option>
            <el-option :value="2" label="酒店卡"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="conditions.keywords"/>
        </el-form-item>
        <div>
          <el-button type="primary" @click="jumpTo(1)">
            搜索
          </el-button>
          <el-button type="primary" @click="newDivision">
            制卡
          </el-button>
        </div>
      </el-form>
    </el-header>
    <el-main>
      <el-table :data="scenicSpots">
        <el-table-column prop="id" label="卡片ID"/>
        <el-table-column prop="serialNumber" label="卡号"/>
        <el-table-column prop="cardType" label="类型"/>
        <el-table-column prop="password" label="密码"/>
        <el-table-column prop="userName" label="用户名"></el-table-column>
      </el-table>
      <el-pagination @current-change="jumpTo" :page-size="pagination.pageSize" :total="pagination.total">

      </el-pagination>
    </el-main>
  </el-container>
</template>
<script>
import division from '../../../constants/divisions.json'
import {onMounted, reactive, ref} from 'vue'
import {useRouter} from 'vue-router'
import axios from '../../../request'
import usePagination from '../../../hooks/usePagination'
import useDeleteScenicSpots from '../../../hooks/useDeleteScenicSpots'

export default {
  setup() {
    const scenicSpots = ref([])
    const conditions = reactive({
      cardType: null,
      keywords: ''
    })

    const loading = ref(false)

    const router = useRouter()
    const newDivision = () => {
      router.push({name: 'NewCards'})
    }

    const search = async (pagination) => {
      loading.value = true
      const {records, pagination: pagi} = await axios.get('/cards/', {
        params: {
          pagination,
          conditions
        }
      })
      scenicSpots.value = records
      return pagi
    }

    const {pagination, jumpTo} = usePagination(search)

    onMounted(() => {
      jumpTo(1)
    })

    const deleteScenic = useDeleteScenicSpots(() => search(pagination))

    return {
      deleteScenic,
      newDivision,
      division,
      conditions,
      pagination, jumpTo,
      scenicSpots,
      search
    }
  }
}
</script>
